import React from 'react';
import Icon from '../../../components/AppIcon';
import { cn } from '../../../utils/cn';

const IntakeProgressBar = ({ steps, currentStep, onStepClick }) => {
  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <div className="flex items-center justify-between">
        {steps?.map((step, index) => (
          <React.Fragment key={step?.id}>
            <button
              onClick={() => onStepClick(step?.id)}
              className={cn(
                "flex flex-col items-center gap-2 transition-all",
                step?.id <= currentStep ? "cursor-pointer" : "cursor-not-allowed opacity-50"
              )}
              disabled={step?.id > currentStep}
            >
              <div className={cn(
                "flex items-center justify-center w-12 h-12 rounded-full border-2 transition-all",
                step?.id === currentStep && "border-primary bg-primary text-primary-foreground",
                step?.id < currentStep && "border-success bg-success text-success-foreground",
                step?.id > currentStep && "border-border bg-background text-muted-foreground"
              )}>
                <Icon 
                  name={step?.id < currentStep ? 'Check' : step?.icon} 
                  size={20} 
                />
              </div>
              <div className="text-center">
                <p className={cn(
                  "text-sm font-medium",
                  step?.id === currentStep && "text-primary",
                  step?.id < currentStep && "text-success",
                  step?.id > currentStep && "text-muted-foreground"
                )}>
                  {step?.name}
                </p>
              </div>
            </button>
            
            {index < steps?.length - 1 && (
              <div className="flex-1 h-0.5 mx-4 bg-border relative">
                <div 
                  className={cn(
                    "absolute inset-0 transition-all duration-300",
                    step?.id < currentStep ? "bg-success" : "bg-transparent"
                  )}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default IntakeProgressBar;